export default __webpack_public_path__ + "static/media/DesktopLine4.ef844f05.svg";